import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Container,
  ListItemText,
  Menu,
  MenuItem,
  Button as MuiButton,
} from "@mui/material";
import { useState } from "react";
import Button from "../../../components/CustomButton";
import CustomSelect from "../../../components/Select/Select";
import { AppColors } from "../../../util/AppColors";
import AppointmentsFacilityReport from "./Appointments/AppointmentsFacilityReport";
import AppointmentsTableReport from "./Appointments/AppointmentsTableReport";
import AppointmentsTabTableReport from "./Appointments/AppointmentsTabTableReport";
import BillingCollectionsTableReport from "./Billing/BillingCollectionsTableReport";
import BillingInvoicesTableReport from "./Billing/BillingInvoicesTableReport";
import BillingPurchaseReturnReport from "./Billing/BillingPurchaseReturnReport";
import BillingSalesReturnReport from "./Billing/BillingSalesReturnReport";
import AppointmentsReport from "./Pets/AppointmentsReport";
import PetDetailsReport from "./Pets/PetDetailsReport";
import ServiceLevel2Report from "./Service/ServiceLevel2Report";
import ServiceTableReport from "./Service/ServiceTableReport";
import StockBatchReport from "./Stock/StockBatchReport";
import StockDumpReport from "./Stock/StockDumpReport";
import StockPurchaseReturnReport from "./Stock/StockPurchaseReturnReport";
import StockSalesReturnReport from "./Stock/StockSalesReturnReport";
import VetsRevenueReport from "./Vets/VetsRevenueReport";
import VetsSlotsReport from "./Vets/VetsSlotsReport";
import VetsSpecialityReport from "./Vets/VetsSpecialityReport";
import VetsUpcomingReport from "./Vets/VetsUpcomingReport";

const tabArray = [
  {
    name: "Vets",
    tabs: [
      "Vet Performance",
      "Vet Specialties",
      "Utilization vs Capacity",
      // "Delay",
      "Upcoming Appointments",
    ],
  },
  { name: "Pets", tabs: ["Pet Overview", "Appointment History"] },
  {
    name: "Appointments",
    tabs: [
      "Appointment Trends",
      "Appointment Analytics",
      "Facility Utilization",
    ],
  },
  {
    name: "Billing",
    tabs: [
      "Revenue Report",
      "Collections Report",
      {
        type: "dropdown",
        label: "Returns Report",
        options: [
          { value: "Sales Return", label: "Sales" },
          { value: "Purchase Return", label: "Purchase" },
        ],
      },
    ],
  },
  {
    name: "Stock",
    tabs: ["Stock Overview", "Batch Analysis", "Stock Returns"],
  },
  { name: "Services", tabs: ["Service Analytics", "Service Usage"] },
];

const Reports = () => {
  // Selected sub-tab per group (e.g. { Vets: "Revenue", Pets: "Appointments" })
  const [selectedTabsByGroup, setSelectedTabsByGroup] = useState(() =>
    tabArray.reduce(
      (acc, { name, tabs }) => ({ ...acc, [name]: tabs?.[0] }),
      {},
    ),
  );
  const [activeTab, setActiveTab] = useState("Vets");
  const [returnsReportAnchor, setReturnsReportAnchor] = useState(null);
  const [selectedDrop, setSelectedDrop] = useState("Sales");

  const handleMainTabClick = (groupName) => {
    setActiveTab(groupName);
  };

  const handleSubTabClick = (groupName, subTab) => {
    setSelectedTabsByGroup((prev) => ({ ...prev, [groupName]: subTab }));
  };

  const selectedTab = selectedTabsByGroup[activeTab];
  const activeGroup = tabArray?.find((group) => group.name === activeTab);

  return (
    <Container maxWidth="xl">
      <div className="com-mar back-white ph20 pt10 pb10">
        {/* Primary Tabs - Main Categories */}
        <div
          className="flex-row-ali-cen"
          style={{ flexWrap: "wrap", gap: "8px", marginBottom: "10px" }}
        >
          {tabArray?.map((li, i) => (
            <div key={`${li?.name}_${i}`} style={{ marginRight: "8px" }}>
              <Button
                text={li?.name}
                tabSelectdBtn={activeTab === li?.name}
                textBtn={activeTab !== li?.name}
                color={AppColors.grayBtn2}
                onClick={() => handleMainTabClick(li?.name)}
              />
            </div>
          ))}
        </div>

        {/* Secondary Tabs - Sub-items for Active Category */}
        {activeGroup && activeGroup?.tabs && activeGroup?.tabs?.length > 1 && (
          <div
            className="flex-row-ali-cen"
            style={{
              flexWrap: "wrap",
              gap: "8px",
              // marginBottom: "16px",
              paddingTop: "8px",
              borderTop: "1px solid #e0e0e0",
            }}
          >
            {activeGroup?.tabs?.map((item, ind) => {
              if (typeof item === "object" && item?.type === "dropdown") {
                const isSelected = item?.options?.some(
                  (opt) => opt.value === selectedTab,
                );
                const selectedOption = item?.options?.find(
                  (opt) => opt.value === selectedTab,
                );
                return (
                  <div
                    key={`${item?.label}_${ind}`}
                    style={{ marginRight: "8px" }}
                  >
                    <MuiButton
                      size="small"
                      variant={isSelected ? "contained" : "outlined"}
                      onClick={(e) => setReturnsReportAnchor(e.currentTarget)}
                      endIcon={<KeyboardArrowDownIcon />}
                      sx={{
                        fontSize: 14,
                        borderRadius: "5px",
                        height: 30,
                        textTransform: "capitalize",
                        fontWeight: 600,
                        px: 1.25,
                        fontFamily: "Montserrat",
                        boxShadow: "none",
                        backgroundColor: isSelected
                          ? AppColors.yellowBtn
                          : "transparent",
                        borderColor: isSelected
                          ? AppColors.yellowBtn
                          : AppColors.appPrimary,
                        color: isSelected ? AppColors.white : AppColors.gray3,
                        "&:hover": {
                          boxShadow: "none",
                          backgroundColor: isSelected
                            ? AppColors.yellowBtn
                            : "rgba(0,0,0,0.04)",
                          borderColor: isSelected
                            ? AppColors.yellowBtn
                            : AppColors.appPrimary,
                        },
                      }}
                    >
                      {selectedOption
                        ? `${item?.label} (${selectedOption.label})`
                        : item.label}
                    </MuiButton>
                    <Menu
                      anchorEl={returnsReportAnchor}
                      open={Boolean(returnsReportAnchor)}
                      onClose={() => setReturnsReportAnchor(null)}
                      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                      transformOrigin={{ vertical: "top", horizontal: "left" }}
                      PaperProps={{
                        sx: { minWidth: 160, mt: 1.5, boxShadow: "none" },
                      }}
                    >
                      {item.options?.map((opt) => (
                        <MenuItem
                          key={opt.value}
                          onClick={() => {
                            handleSubTabClick(activeTab, opt.value);
                            setReturnsReportAnchor(null);
                          }}
                        >
                          <ListItemText primary={opt?.label} />
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                );
              }
              const subTab =
                typeof item === "string" ? item : (item?.label ?? item);
              return (
                <div key={`${subTab}_${ind}`} style={{ marginRight: "8px" }}>
                  <Button
                    text={subTab}
                    smallBtn
                    tabOutlined
                    yellowBtn={selectedTab === subTab}
                    onClick={() => handleSubTabClick(activeTab, subTab)}
                  />
                </div>
              );
            })}
            {selectedTab === "Stock Returns" && (
              <div className="flex1-end">
                <div className="w15Per">
                  <CustomSelect
                    list={[
                      { name: "Sales", value: "Sales" },
                      { name: "Purchase", value: "Purchase" },
                    ]}
                    value={selectedDrop}
                    handleChange={(e) => setSelectedDrop(e?.target?.value)}
                    select
                  />
                </div>
              </div>
            )}
          </div>
        )}
        <div className="mt10 mh20Min">
          {activeTab === "Vets" ? (
            selectedTab === "Vet Performance" ? (
              <VetsRevenueReport />
            ) : selectedTab === "Vet Specialties" ? (
              <VetsSpecialityReport />
            ) : selectedTab === "Utilization vs Capacity" ? (
              <VetsSlotsReport />
            ) : //  :  selectedTab === "Delay" ? (
            //   <VetsDelayReport />
            // )
            selectedTab === "Upcoming Appointments" ? (
              <VetsUpcomingReport />
            ) : null
          ) : null}
          {activeTab === "Pets" ? (
            selectedTab === "Appointment History" ? (
              <AppointmentsReport />
            ) : selectedTab === "Pet Overview" ? (
              <PetDetailsReport />
            ) : null
          ) : null}
          {activeTab === "Appointments" ? (
            selectedTab === "Appointment Trends" ? (
              <AppointmentsTableReport />
            ) : selectedTab === "Appointment Analytics" ? (
              <AppointmentsTabTableReport />
            ) : selectedTab === "Facility Utilization" ? (
              <AppointmentsFacilityReport />
            ) : null
          ) : null}
          {activeTab === "Billing" ? (
            // selectedTab === "Revenue" ? (
            //   <BillingRevenueReport />
            // ) :
            selectedTab === "Revenue Report" ? (
              <BillingInvoicesTableReport />
            ) : selectedTab === "Collections Report" ? (
              <BillingCollectionsTableReport />
            ) : selectedTab === "Sales Return" ? (
              <BillingSalesReturnReport />
            ) : selectedTab === "Purchase Return" ? (
              <BillingPurchaseReturnReport />
            ) : null
          ) : null}
          {activeTab === "Stock" ? (
            selectedTab === "Stock Overview" ? (
              <StockDumpReport />
            ) : selectedTab === "Batch Analysis" ? (
              <StockBatchReport />
            ) : selectedTab === "Stock Returns" ? (
              selectedDrop === "Sales" ? (
                <StockSalesReturnReport />
              ) : selectedDrop === "Purchase" ? (
                <StockPurchaseReturnReport />
              ) : null
            ) : null
          ) : null}
          {/* selectedTab === "Return" ? (
            <StockReturnReport />
           ) */}
          {activeTab === "Services" ? (
            selectedTab === "Service Analytics" ? (
              <ServiceTableReport />
            ) : selectedTab === "Service Usage" ? (
              <ServiceLevel2Report />
            ) : null
          ) : null}
        </div>
        {/* {selectedTab === "Overview" ? <ReportOverview /> : <DownloadReports />} */}
      </div>
    </Container>
  );
};

export default Reports;
